module.exports = __webpack_public_path__ + "zvetseni-prsou_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_4_before.jpg
// module id = 1344
// module chunks = 0